import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const TidalModalWrapper = styled.div<{ isOpen }>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(190, 195, 209, 0.76);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
`;

const TidalModalAnimater = styled.div`
  transform: translateY(-100%);
  opacity: 0;
  transition: all 0.3s ease-in-out;
  max-width: 95%;
`;

interface ITidalModal {
  Modal: JSX.Element;
  isOpen: boolean;
  onClose: () => void;
}

const TidalModal = ({ Modal, isOpen, onClose }: ITidalModal): JSX.Element => {
  const wrapperRef = useRef();
  const animaterRef = useRef<any>();
  const [isOpenState, setIsOpenState] = useState(isOpen);

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    (async () => {
      if (!animaterRef.current) {
        return;
      }
      if (isOpen) {
        setIsOpenState(true);
        await sleep(100);
        animaterRef.current.style.opacity = 1;
        animaterRef.current.style.transform = 'translateY(0)';
        document.body.style.overflow = 'hidden';
      } else {
        animaterRef.current.style.transform = 'translateY(-100%)';
        animaterRef.current.style.opacity = 0;
        await sleep(200);
        setIsOpenState(false);
        document.body.style.overflow = 'auto';
      }
    })();
  }, [isOpen]);

  return (
    <TidalModalWrapper ref={wrapperRef} onClick={onClose} isOpen={isOpenState}>
      <TidalModalAnimater
        onClick={(e) => {
          e.stopPropagation();
        }}
        ref={animaterRef}
      >
        {isOpenState && Modal}
      </TidalModalAnimater>
    </TidalModalWrapper>
  );
};

export default TidalModal;
